import { render } from "./HotCountryFix.vue?vue&type=template&id=891c6588&scoped=true"
import script from "./HotCountryFix.vue?vue&type=script&lang=js"
export * from "./HotCountryFix.vue?vue&type=script&lang=js"

import "./HotCountryFix.vue?vue&type=style&index=0&id=891c6588&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-891c6588"]])

export default __exports__